import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import HeaderMenuSmallActions from 'reducers/headerMenuSmall';
import NavbarActions from 'reducers/navbar';
import SessionActions from 'reducers/session';
import SearchActions from 'reducers/searchParams';
import SearchFiltersActions from 'reducers/searchFilters';

import {
  BOOKINGS, HOME, MY_PROFILE, PAYMENT_METHODS, SIGN_IN, SIGN_UP,
} from 'utils/routes';
import { UPCOMING } from 'utils/bookingStatus';
import { matchRoute } from 'utils/routeHelpers';

const mapStateToProps = ({
  ui, profile, location, router, affiliate, city, courseDetail,
}) => ({
  isLoggedIn: profile?.loggedIn,
  location,
  open: ui?.headerMenuSmall?.open,
  router,
  storeUrl: affiliate?.storeUrl,
  city,
  course: courseDetail?.course,
  avatarUrl: profile?.avatarUrl,
  isHome: matchRoute(HOME, router.location?.pathname),
  activeItem: ui?.navbar?.activeNavItem,
  pathname: router.location?.pathname,
  search: router.location?.search,
});

const mapDispatchToProps = (dispatch) => ({
  goToMyBookings: () => { dispatch(push(BOOKINGS.replace(':status', UPCOMING))); },
  goToMyProfile: () => { dispatch(push(MY_PROFILE)); },
  goToPaymentsMethods: () => { dispatch(push(PAYMENT_METHODS)); },
  goToSignIn: () => { dispatch(push(SIGN_IN)); },
  goToSignUp: () => { dispatch(push(SIGN_UP)); },
  goTo: (path) => { dispatch(push(path)); },
  hardResetFilters: () => { dispatch(SearchActions.hardResetFilters()); },
  performSearch: (forcedEntity) => { dispatch(SearchActions.performSearch(forcedEntity)); },
  setHotDealsSearch: () => {
    dispatch(SearchActions.setDealsOnlyOn(['is_lightning_rate']));
    dispatch(SearchFiltersActions.setSortByCourses('price-lowest-first'));
  },
  setLocationFilter: (location) => { dispatch(SearchActions.setLocationFilter(location)); },
  setNearMeSearch: () => {
    dispatch(SearchActions.setDealsOnlyOff([]));
    dispatch(SearchFiltersActions.setSortByCourses('distance'));
  },
  setRedirectTo: (path) => { dispatch(SessionActions.redirectTo(path)); },
  signOut: () => { dispatch(SessionActions.signOut(true)); },
  toggleHeaderMenu: () => { dispatch(HeaderMenuSmallActions.toggleHeaderMenu()); },
  setLocation: (location) => { dispatch(SearchActions.setLocation(location)); },
  setActiveItem: (navItem) => { dispatch(NavbarActions.setActiveNavItem(navItem)); },
  goBack: (backToUrl) => { dispatch(SearchActions.goBack(backToUrl)); },
});

export default connect(mapStateToProps, mapDispatchToProps);
